export function buildInventoryStockLabels(products, catalogBarcodes = []) {
  return products.map(item => {
    const catalog = catalogBarcodes.find(row => String(row.id || row.product_barcode_id) === String(item.product_barcode_id)) || {};
    const barcode = String(item.mk_barcode || item.bar_code || catalog.mk_barcode || '').trim();
    const mrp = Number(item.unit_mrp ?? item.unit_MRP ?? item.inventory_unit_mrp ?? item.mrp_amount ?? item.mrp);
    const available = Math.floor(Number(item.count_in_stock ?? item.no_of_units ?? 0));
    const quantity = item.barcode_quantity ?? item.quantity ?? catalog.quantity;
    const unit = item.unit_short_code || item.unit_name || catalog.unit_short_code || catalog.unit_name || '';
    const reason = item._stockDraft ? 'Publish stock changes before printing.'
      : item.is_active === false || !(available > 0) ? 'No available stock.'
      : !/^\d{8,}$/.test(barcode) ? 'Saved product barcode is missing.'
      : !(mrp > 0 && Number.isFinite(mrp)) ? 'Set and save the inventory MRP first.'
      : !(Number(quantity) > 0) || !unit ? 'Saved pack size is missing.' : '';
    return { ...item, id: item.id, inventory_label: true, mk_barcode: barcode,
      product_name: item.product_name || item.product_name_eng || catalog.product_name_eng,
      product_name_tel: item.product_name_tel || catalog.product_name_tel,
      unitText: `${Number(quantity)} ${unit}`, mrp_amount: mrp, unit_mrp: mrp, available, reason };
  });
}
